/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import HighLevelDataType from './HighLevelDataType';
import UsageType from './UsageType';
import RegularAggregateType from './RegularAggregateType';
import Module from './Module';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (static) // HighLevelDataType
//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (static) // UsageType
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // new

/**
 * A utility class that can be translated to Javascript Use by both Java and Javascript code. note 1:  In JS, If search argument is a string, replaceAll() replaces all occurrences of search with replaceWith, while replace() only the first occurrence. Use replaceAll until translator can translate replace to replaceAll if search argument is a string.   
 * @author  PASCALLacombe
 */
export default class MoserCommonUtils extends BaseMoserObject{

	static ID_KEY = "id";

	static MY_FOLDERS = ".my_folders";

	static SPACE = " ";

	static UNDERSCORE = "_";

	static XQEDT_TIME_TZ = "TIME WITH TIME ZONE";

	static XQEDT_TIMESTAMP_TZ = "TIMESTAMP WITH TIME ZONE";

	static XQEDT_STRING = "STRING";

	static DT_NVARCHAR_MAX = "NVARCHAR(MAX)";

	static DT_TIME_TZ = "TIME_TZ";

	static DT_TIMESTAMP_TZ = "TIMESTAMP_TZ";

	static DT_BIT = "BIT";

	static DT_BOOLEAN = "BOOLEAN";

	static DT_CHAR = "CHAR";

	static DT_LONGNVARCHAR = "LONGNVARCHAR";

	static DT_LONGVARCHAR = "LONGVARCHAR";

	static DT_NCHAR = "NCHAR";

	static DT_NVARCHAR = "NVARCHAR";

	static DT_VARCHAR = "VARCHAR";

	static DT_DATALINK = "DATALINK";

	static DT_JSON = "JSON";

	static DT_SQLXML = "SQLXML";

	static DT_CLOB = "CLOB";

	static DT_NCLOB = "NCLOB";

	static DT_BIGINT = "BIGINT";

	static DT_DOUBLE = "DOUBLE";

	static DT_FLOAT = "FLOAT";

	static DT_INTEGER = "INTEGER";

	static DT_REAL = "REAL";

	static DT_SMALLINT = "SMALLINT";

	static DT_TINYINT = "TINYINT";

	static DT_DECIMAL = "DECIMAL";

	static DT_LONG = "LONG";

	static DT_NUMERIC = "NUMERIC";

	static DT_DATE = "DATE";

	static DT_TIME = "TIME";

	static DT_TIMESTAMP = "TIMESTAMP";

	static DT_INTERVAL_YEAR = "INTERVAL_YEAR";

	static DT_INTERVAL_YEAR_TO_MONTH = "INTERVAL_YEAR_TO_MONTH";

	static DT_INTERVAL_MONTH = "INTERVAL_MONTH";

	static DT_INTERVAL_DAY = "INTERVAL_DAY";

	static DT_INTERVAL_DAY_TO_HOUR = "INTERVAL_DAY_TO_HOUR";

	static DT_INTERVAL_DAY_TO_MINUTE = "INTERVAL_DAY_TO_MINUTE";

	static DT_INTERVAL_DAY_TO_SECOND = "INTERVAL_DAY_TO_SECOND";

	static DT_INTERVAL_HOUR = "INTERVAL_HOUR";

	static DT_INTERVAL_HOUR_TO_MINUTE = "INTERVAL_HOUR_TO_MINUTE";

	static DT_INTERVAL_HOUR_TO_SECOND = "INTERVAL_HOUR_TO_SECOND";

	static DT_INTERVAL_MINUTE = "INTERVAL_MINUTE";

	static DT_INTERVAL_MINUTE_TO_SECOND = "INTERVAL_MINUTE_TO_SECOND";

	static DT_INTERVAL_SECOND = "INTERVAL_SECOND";

	static DT_ARRAY = "ARRAY";

	static DT_ROWSET = "ROWSET";

	static DT_LONGVARBINARY = "LONGVARBINARY";

	static DT_BINARY = "BINARY";

	static DT_VARBINARY = "VARBINARY";

	static DT_BLOB = "BLOB";

	static DT_REF = "REF";

	static DT_DISTINCT = "DISTINCT";

	static DT_JAVA_OBJECT = "JAVA_OBJECT";

	static DT_OTHER = "OTHER";

	static DT_STRUCT = "STRUCT";

	static DT_NULL = "NULL";

	static DT_ROWID = "ROWID";

	static DT_VARIANT = "VARIANT";

	static DT_PERIOD_DATE = "PERIOD_DATE";

	static DT_PERIOD_TIME = "PERIOD_TIME";

	static DT_PERIOD_TIME_TZ = "PERIOD_TIME_TZ";

	static DT_PERIOD_TIMESTAMP = "PERIOD_TIMESTAMP";

	static DT_PERIOD_TIMESTAMP_TZ = "PERIOD_TIMESTAMP_TZ";

	static DT_UNKNOWN = "UNKNOWN";

	/**
	 * Singleton static instance.
	 */
	static instance = new MoserCommonUtils();

	/**
	 * data type name to data type category map.
	 */
	dataTypNameToDTC = null;



	/**
	 * Private constructor.
	 */
	constructor() {
		super();
		this.dataTypNameToDTC = {};
		this.dataTypNameToDTC["BIT"] = HighLevelDataType.BOOLEAN;
		this.dataTypNameToDTC["BOOLEAN"] = HighLevelDataType.BOOLEAN;
		this.dataTypNameToDTC["CHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["LONGNVARCHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["LONGVARCHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["NCHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["NVARCHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["VARCHAR"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["DATALINK"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["JSON"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["SQLXML"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["CLOB"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["NCLOB"] = HighLevelDataType.STRING;
		this.dataTypNameToDTC["BIGINT"] = HighLevelDataType.INTEGER;
		this.dataTypNameToDTC["DOUBLE"] = HighLevelDataType.DECIMAL;
		this.dataTypNameToDTC["FLOAT"] = HighLevelDataType.DECIMAL;
		this.dataTypNameToDTC["INTEGER"] = HighLevelDataType.INTEGER;
		this.dataTypNameToDTC["REAL"] = HighLevelDataType.DECIMAL;
		this.dataTypNameToDTC["SMALLINT"] = HighLevelDataType.INTEGER;
		this.dataTypNameToDTC["TINYINT"] = HighLevelDataType.INTEGER;
		this.dataTypNameToDTC["DECIMAL"] = HighLevelDataType.DECIMAL;
		this.dataTypNameToDTC["LONG"] = HighLevelDataType.INTEGER;
		this.dataTypNameToDTC["NUMERIC"] = HighLevelDataType.DECIMAL;
		this.dataTypNameToDTC["DATE"] = HighLevelDataType.DATE;
		this.dataTypNameToDTC["TIME"] = HighLevelDataType.TIME;
		this.dataTypNameToDTC["TIME_TZ"] = HighLevelDataType.TIME;
		this.dataTypNameToDTC["TIMESTAMP"] = HighLevelDataType.DATETIME;
		this.dataTypNameToDTC["TIMESTAMP_TZ"] = HighLevelDataType.DATETIME;
		this.dataTypNameToDTC["INTERVAL_YEAR"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_YEAR_TO_MONTH"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_MONTH"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_DAY"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_DAY_TO_HOUR"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_DAY_TO_MINUTE"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_DAY_TO_SECOND"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_HOUR"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_HOUR_TO_MINUTE"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_HOUR_TO_SECOND"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_MINUTE"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_MINUTE_TO_SECOND"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["INTERVAL_SECOND"] = HighLevelDataType.INTERVAL;
		this.dataTypNameToDTC["ARRAY"] = HighLevelDataType.ARRAY;
		this.dataTypNameToDTC["ROWSET"] = HighLevelDataType.ARRAY;
		this.dataTypNameToDTC["LONGVARBINARY"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["BINARY"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["VARBINARY"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["BLOB"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["REF"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["DISTINCT"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["JAVA_OBJECT"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["OTHER"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["STRUCT"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["NULL"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["ROWID"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["VARIANT"] = HighLevelDataType.OBJECT;
		this.dataTypNameToDTC["PERIOD_DATE"] = HighLevelDataType.PERIOD;
		this.dataTypNameToDTC["PERIOD_TIME"] = HighLevelDataType.PERIOD;
		this.dataTypNameToDTC["PERIOD_TIME_TZ"] = HighLevelDataType.PERIOD;
		this.dataTypNameToDTC["PERIOD_TIMESTAMP"] = HighLevelDataType.PERIOD;
		this.dataTypNameToDTC["PERIOD_TIMESTAMP_TZ"] = HighLevelDataType.PERIOD;
	}

	/**
	 * Return true if a CM object type is a first class object, meaning it is visible to users.
	 * @param {String} type  - CM object type.
	 * @return {boolean}
	 */
	static isFirstClassObject(type) {
		return MoserCommonUtils.isFolderObject(type) || "package" == type || "dataSource" == type || "dataSourceConnection" == type || MoserCommonUtils.isContentObject(type);
	}

	/**
	 * Return true if a CM object type is a 'account' object.
	 * @param {String} type  - CM object type.
	 * @return {boolean}
	 */
	static isAccountObject(type) {
		return "account" == type;
	}

	/**
	 * Return true if a CM object type is a 'folder' object.
	 * @param {String} type  - CM object type.
	 * @return {boolean}
	 */
	static isFolderObject(type) {
		return "folder" == type;
	}

	/**
	 * Return true if a CM object type if a 'directory' object.
	 */
	static isDirectoryObject(type) {
		return "directory" == type;
	}

	/**
	 * Return true if a CM object type is a 'content' object.
	 * @param {String} type  - CM object type.
	 * @return {boolean}
	 */
	static isContentObject(type) {
		return "content" == type;
	}

	/**
	 * Get the scale of a data type, return null if cannot be determined.
	 * @param {String} dataType
	 * @param {HighLevelDataType} hld  			HighLevelDataType.
	 * @return {Number}
	 */
	static _retrieveScaleFromDataTypeAndHighLevelDataType(dataType, hld) {
		var dt = dataType.trim();
		var index1 = dt.indexOf("(");
		var index2 = dt.indexOf(")");
		if (index1 == -1 || index2 == -1) {
			if (!hld) {
				var jmdDataType = MoserCommonUtils.getJMDDataTypeName(dataType);
				hld = MoserCommonUtils.instance.dataTypNameToDTC[jmdDataType];
			}
			return HighLevelDataType.INTEGER === hld ? new Number(0) : null;
		}
		dt = dt.substring(index1 + 1, index2).replace(new RegExp(" ","g"), "");
		var index = dt.indexOf(",");
		return index == -1 ? new Number(0) : new Number(dt.substring(index + 1));
	}

	/**
	 * Generate HighLevelDatatype Category from data type.
	 * @param {String} dataType  data type string.
	 * @return {HighLevelDataType}  HighLevelDataType.
	 */
	static generateHighlevelDatatype(dataType) {
		if (dataType == null) {
			return HighLevelDataType.INTEGER;
		}
		var jmdDataType = MoserCommonUtils.getJMDDataTypeName(dataType);
		var hld = MoserCommonUtils.instance.dataTypNameToDTC[jmdDataType];
		if (HighLevelDataType.DECIMAL === hld && ("NUMERIC" == jmdDataType || "DECIMAL" == jmdDataType)) {
			var scale = MoserCommonUtils._retrieveScaleFromDataTypeAndHighLevelDataType(dataType, hld);
			return scale != null && scale <= 0 ? HighLevelDataType.INTEGER : hld;
		}
		return hld;
	}

	/**
	 * Get the precision of a data type, return null if cannot be determined.
	 * @param {String} dataType
	 * @return {Number}
	 */
	static getPrecision(dataType) {
		var dt = dataType.trim();
		var index1 = dt.indexOf("(");
		var index2 = dt.indexOf(")");
		if (index1 == -1 || index2 == -1) {
			return null;
		}
		dt = dt.substring(index1 + 1, index2).replace(new RegExp(" ","g"), "");
		var index = dt.indexOf(",");
		return index == -1 ? new Number(dt) : new Number(dt.substring(0, index));
	}

	/**
	 * Get the scale of a data type, return null if cannot be determined.
	 * @param {String} dataType
	 * @return {Number}
	 */
	static getScale(dataType) {
		return MoserCommonUtils._retrieveScaleFromDataTypeAndHighLevelDataType(dataType, null);
	}

	/**
	 * get JMD data type name.
	 * @param {String} dataType  the data type.
	 * @return {String}  JMD data type name.
	 */
	static getJMDDataTypeName(dataType) {
		var dt = dataType.trim().toUpperCase();
		var index = dt.indexOf("(");
		if (index != -1) {
			dt = dt.substring(0, index);
		}
		if ("TIME WITH TIME ZONE" == dt) {
			return "TIME_TZ";
		} else if ("TIMESTAMP WITH TIME ZONE" == dt) {
			return "TIMESTAMP_TZ";
		} else if ("STRING" == dt) {
			return "NVARCHAR(MAX)";
		}
		return dt.replace(new RegExp(" ","g"), "_");
	}

	/**
	 * get usage according to high level type (FM rule). identifier: 			date/time/datetime fact: 				numeric/interval attribute: 			string automatic: 			other
	 * @param {HighLevelDataType} highDT  - HighLevelDataType.
	 * @return {UsageType}  usage.
	 */
	static getUsageFromHighLevelDataType(highDT) {
		if (HighLevelDataType.DATE === highDT || HighLevelDataType.TIME === highDT || HighLevelDataType.DATETIME === highDT) {
			return UsageType.IDENTIFIER;
		}
		if (HighLevelDataType.INTEGER === highDT || HighLevelDataType.DECIMAL === highDT || HighLevelDataType.INTERVAL === highDT) {
			return UsageType.FACT;
		}
		if (HighLevelDataType.STRING === highDT) {
			return UsageType.ATTRIBUTE;
		}
		return UsageType.AUTOMATIC;
	}

	/**
	 * get RegularAggregateType according to Usage And High Level DataType.
	 * @param {UsageType} usage   - usage.
	 * @param {HighLevelDataType} highDT  - HighLevelDataType.
	 * @return {RegularAggregateType}
	 */
	static getRegularAggregateTypeFromUsageAndHighLevelDataType(usage, highDT) {
		if (UsageType.AUTOMATIC === usage) {
			return RegularAggregateType.NONE;
		}
		if (UsageType.IDENTIFIER === usage || UsageType.ATTRIBUTE === usage) {
			return RegularAggregateType.COUNT_DISTINCT;
		}
		return MoserCommonUtils.getRegularAggregateTypeFromHighLevelDataType(highDT);
	}

	/**
	 * get RegularAggregateType according to High Level DataType.
	 * @param {HighLevelDataType} highDT  - HighLevelDataType.
	 * @return {RegularAggregateType}
	 */
	static getRegularAggregateTypeFromHighLevelDataType(highDT) {
		if (HighLevelDataType.DATE === highDT || HighLevelDataType.TIME === highDT || HighLevelDataType.DATETIME === highDT) {
			return RegularAggregateType.MAXIMUM;
		}
		if (HighLevelDataType.INTEGER === highDT || HighLevelDataType.DECIMAL === highDT || HighLevelDataType.INTERVAL === highDT) {
			return RegularAggregateType.TOTAL;
		}
		return RegularAggregateType.COUNT;
	}

	/**
	 * check if data types are compatible. use the rule in DataTypeComparator.areCompatibleDataTypes
	 * @param {String} lDataType
	 * @param {String} rDataType
	 * @return {boolean}  t/f.
	 */
	static areCompatibleDataTypes(lDataType, rDataType) {
		if (lDataType == null || rDataType == null) {
			return false;
		}
		var leftDTName = MoserCommonUtils.getJMDDataTypeName(lDataType);
		var rightDTName = MoserCommonUtils.getJMDDataTypeName(rDataType);
		var leftHighDT = MoserCommonUtils.instance.dataTypNameToDTC[leftDTName];
		var rightHighDT = MoserCommonUtils.instance.dataTypNameToDTC[rightDTName];
		if (!leftHighDT || !rightHighDT) {
			return false;
		}
		if (leftDTName == "NULL" || rightDTName == "NULL") {
			return true;
		}
		if (leftDTName == rightDTName) {
			return true;
		}
		if (leftDTName == "UNKNOWN" || rightDTName == "UNKNOWN") {
			return false;
		}
		if (leftHighDT == HighLevelDataType.STRING && rightHighDT == HighLevelDataType.STRING) {
			return true;
		}
		if ((leftHighDT == HighLevelDataType.INTEGER || leftHighDT == HighLevelDataType.DECIMAL) && (rightHighDT == HighLevelDataType.INTEGER || rightHighDT == HighLevelDataType.DECIMAL)) {
			return true;
		}
		if (leftHighDT == HighLevelDataType.BOOLEAN && rightHighDT == HighLevelDataType.BOOLEAN) {
			return true;
		}
		if (leftHighDT == HighLevelDataType.DATE && rightHighDT == HighLevelDataType.DATE) {
			return true;
		}
		if (leftHighDT == HighLevelDataType.TIME && rightHighDT == HighLevelDataType.TIME) {
			return true;
		}
		if (leftHighDT == HighLevelDataType.DATETIME && rightHighDT == HighLevelDataType.DATETIME) {
			return true;
		}
		if (leftHighDT == HighLevelDataType.DATE) {
			return rightHighDT == HighLevelDataType.DATETIME;
		} else if (leftHighDT == HighLevelDataType.DATETIME) {
			return rightHighDT == HighLevelDataType.DATE;
		}
		if (leftHighDT == HighLevelDataType.INTERVAL && rightHighDT == HighLevelDataType.INTERVAL) {
			return (leftDTName == "INTERVAL_YEAR" || leftDTName == "INTERVAL_YEAR_TO_MONTH" || leftDTName == "INTERVAL_MONTH") && (rightDTName == "INTERVAL_YEAR" || rightDTName == "INTERVAL_YEAR_TO_MONTH" || rightDTName == "INTERVAL_MONTH");
		}
		return false;
	}

	/**
	 * Create a list of Ancestors by parsing a JSONArray that is returned with /sources calls.
	 * @param {Array} ancestorsResp
	 * @param {String} myFoldersLabel
	 * @param {String} teamContentLabel
	 * @return {Array}
	 */
	static createAncestors(ancestorsResp, myFoldersLabel, teamContentLabel) {
		var ancestors = [];
		if (!ancestorsResp || ancestorsResp.length==0) {
			return ancestors;
		}
		var parentType;
		for (var __i_enFor0 = 0, __exp_enFor0 = ancestorsResp, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var o = __exp_enFor0[__i_enFor0];
			var a = o;
			var type = a["type"];
			if (!(MoserCommonUtils.isFirstClassObject(type)) && !(MoserCommonUtils._isMyFolderGlass(type, parentType, a["id"]))) {
				parentType = type;
				continue;
			}
			var defaultName = MoserCommonUtils._getDefaultName(type, a, parentType, myFoldersLabel, teamContentLabel);
			if (defaultName == null) {
				parentType = type;
				continue;
			}
			var ancestor = new Module.UseSpec.Ancestors();
			ancestor.setDefaultName(defaultName);
			if (type != null && MoserCommonUtils._isMyFolder(type, parentType)) {
				ancestor.setStoreID(".my_folders");
			} else if (type != null && MoserCommonUtils._isTeamContent(type, parentType)) {
				ancestor.setStoreID(".public_folders");
			} else {
				var id = a["id"];
				if (id != null) {
					ancestor.setStoreID(id);
				}
			}
			parentType = type;
			ancestors.push(ancestor);
		}
		return ancestors;
	}

	/**
	 * Identify .my_folders passed from glass
	 * @param {String} type  passed by glass "directory"
	 * @param {String} parentType  passed by glass null
	 * @param {String} id  passed by glass ".my_folders"
	 * @return {boolean}  true if all are true.
	 */
	static _isMyFolderGlass(type, parentType, id) {
		return parentType == null && MoserCommonUtils.isDirectoryObject(type) && ".my_folders" == id;
	}

	/**
	 * Get the defaultName to use for a given ancestor.
	 * @param {String} type
	 * @param {Object} a
	 * @param {String} parentType
	 * @param {String} myFoldersLabel
	 * @param {String} teamContentLabel
	 * @return {String}
	 */
	static _getDefaultName(type, a, parentType, myFoldersLabel, teamContentLabel) {
		var defaultName = a["name"];
		if (defaultName == null) {
			defaultName = a["defaultName"];
		}
		if (myFoldersLabel != null && MoserCommonUtils._isMyFolder(type, parentType)) {
			return myFoldersLabel;
		}
		if (teamContentLabel != null && MoserCommonUtils._isTeamContent(type, parentType)) {
			return teamContentLabel;
		}
		return defaultName;
	}

	/**
	 * Determines whether the ancestor came from My Folders
	 * @param {String} type
	 * @param {String} parentType
	 * @return {boolean}
	 */
	static _isMyFolder(type, parentType) {
		return parentType == null && MoserCommonUtils.isDirectoryObject(type) || MoserCommonUtils.isAccountObject(parentType) && MoserCommonUtils.isFolderObject(type);
	}

	/**
	 * Determines whether the ancestor came from Team Content
	 * @param {String} type
	 * @param {String} parentType
	 * @return {boolean}
	 */
	static _isTeamContent(type, parentType) {
		return MoserCommonUtils.isContentObject(type) && parentType == null;
	}
}


// WEBPACK FOOTER //
// ./src/generated/MoserCommonUtils.js